
import React from 'react';
import BackgroundImage from "./BackgroundImage";

function BuyPacks() {
    return <BackgroundImage />;
}

export default BuyPacks;
